const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
const API_BASE_URL_LIST = {
  "development":  "https://pzj5ji42gb.execute-api.ap-northeast-1.amazonaws.com/api",
  "staging":     "https://xexcoshs82.execute-api.ap-northeast-1.amazonaws.com/api",
  "production": "https://ny43l5e4pe.execute-api.ap-northeast-1.amazonaws.com/api"
}
const API_BASE_URL = API_BASE_URL_LIST[env_key]

const API_ID = "HAWAII"
const TOKEN_KEY = "myPlanToken"
const RECOVERY_CODE_KEY = "HawaiiMaaSRecoveryCode"
const API_MIXWAY_PATH = "https://mixway.ekispert.jp/v1/json/"
const API_KEY = "j8bs7t3fS6ckVZ3h"
const AVAILABLE_LANGUAGES = ['ja', 'en', 'zh-TW']

const JREAST_APP_SCHEMA = "https://jreastapp.page.link"
const JREAST_PC_SITE = "https://play.google.com/store/apps/details?id=jp.co.jreast&hl=ja"
const MIXWAY_URL = "https://mixway.ekispert.net"

// 中心となる駅
const DEFAULT_STATION_LOCATION = {
  latitude: 21.3245132,
  longitude: -157.9272676
}
const DEFAULT_STATION = "東京"

const LINK_BASE_URL_LIST = {
  "development": "https://dev.okukyoto-maas.com",
  "staging": "https://stg.okukyoto-maas.com",
  "production": "https://okukyoto-maas.com"
}

const FREEPASS_URL_LIST = {
  "ticket-eiden-pass": "/tickets/detail/iGs26zjyd7oh5Y9tRFcFR9",
  "ticket-eiden-24": "/tickets/detail/8YbvHdU4gt3s5YDtAkLdcr",
  "ticket-eiden-36": "/tickets/detail/6WuaUchGZ2FFaKUUA8wJpq"
}

const QUESTIONNAIRE_URL = "https://docs.google.com/forms/d/e/1FAIpQLSfpsOfYhKYCsQ0LDpveDltPn0dS77kLSaK-2FYIl7RmRR4blQ/viewform"

export default {
  API_BASE_URL: API_BASE_URL,
  API_ID: API_ID,
  TOKEN_KEY: TOKEN_KEY,
  RECOVERY_CODE_KEY: RECOVERY_CODE_KEY,
  API_MIXWAY_PATH: API_MIXWAY_PATH,
  API_KEY: API_KEY,
  AVAILABLE_LANGUAGES: AVAILABLE_LANGUAGES,
  DEFAULT_STATION_LOCATION: DEFAULT_STATION_LOCATION,
  DEFAULT_STATION: DEFAULT_STATION,
  JREAST_APP_SCHEMA: JREAST_APP_SCHEMA,
  JREAST_PC_SITE: JREAST_PC_SITE,
  MIXWAY_URL: MIXWAY_URL,
  LINK_BASE_URL_LIST: LINK_BASE_URL_LIST,
  FREEPASS_URL_LIST: FREEPASS_URL_LIST,
  QUESTIONNAIRE_URL: QUESTIONNAIRE_URL
}
